import React from "react";
import {drawCircle, drawLine, getHighestFocusPoint, mapMotorToCanvas} from "../utils/map_utils";
import BaseLayer from "./BaseLayer";
import {Grid, Stack} from "@mui/material";
import {getPrefixedUrl} from "../../../utils/utils";
import {getFinalPlotData, getPlotPopup, plotDicyStreak} from "./TileLayersUtils";
import {zProfileFolderPath} from "../../../utils/const";

class FocusDebugLayer extends BaseLayer {

    id = "focusDebug";
    label = "Focus Debug";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {
            multipleWSI3Focus,
            WSI3TestFocusUnits,
            multipleFocusData,
            failedFocus,
            focusOffset,
            focusDirPath,
            focusImgPath,
            tiltFocusPoints,
            focusProfile,
            textColor,
            textSize,
            countyTiltInfo,
            deviceSettings,
            focusPlots,
            slide,
            tileFlag,
            scanFocusDebug,
            takeNumberForDebug
        } = this.props;
        let {y_fields, loc_on_machine, bucket_name, tile_height, uperpixel, tile_viewer_path} = slide;
        
        let highestPoint = getHighestFocusPoint(tiltFocusPoints, focusProfile, countyTiltInfo);
        console.log(`takeNumberForDebug ${takeNumberForDebug}`);
        if (takeNumberForDebug === 1) {
            this.id = "rescanFocusDebug";
            this.label = "Rescan Focus Debug";
        }

        if (takeNumberForDebug === 1) {
            if (scanFocusDebug !== undefined && scanFocusDebug['tissueCheckUnitList'] !== undefined) {
                for (let unit of scanFocusDebug['tissueCheckUnitList']) {
                    let folderLink = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                        "debug/zprofile/" + unit["folder"];
                    let vectorSource = this.layer.getSource();
                    let val = {
                        'motorPosX': unit['position']['xPosition'],
                        'motorPosY': unit['position']['yPosition'],
                        'tissueImgPath': unit["folder"] + "/" + unit['tissueImage'],
                        'nonTissueImgPath': unit["folder"] + "/" + unit['thresholdedImage'],
                        'tissuePercent': unit['tissuePercentage'],
                        'index': "1"
                    };
                    plotDicyStreak(tileFlag, val, this.props.slide, vectorSource, deviceSettings, y_fields,
                        tile_height, uperpixel, textColor, textSize, folderLink);
                }
            }
        }

        if (scanFocusDebug !== undefined && scanFocusDebug['debugUnitMap'] !== undefined) {
            // club fu at same motor coordinates
            let motorPosToFUListDict = {};
            for (let [countyKey, value] of Object.entries(scanFocusDebug['debugUnitMap'])) {
                const takeNumber = value["county"]["countykey"]["islandKey"]["takeNumber"];
                const focusUnits = value["focusUnits"];
                if (takeNumber === takeNumberForDebug) {
                    for (let fu of focusUnits) {
                        let focusedAt = fu['focusedAt'];
                        if (focusedAt !== null) {
                            let motorX = focusedAt['xPosition'];
                            let motorY = focusedAt['yPosition'];
                            let key = `${motorX}_${motorY}`;
                            if (!(key in motorPosToFUListDict)) {
                                motorPosToFUListDict[key] = [];
                            }
                            motorPosToFUListDict[key].push({countyKey: countyKey, fu: fu});
                        }
                    }
                }
            }

            let offset = scanFocusDebug['offset'];

            let countyKeyList = Object.keys(scanFocusDebug['debugUnitMap']);
            for (const countyKey of countyKeyList) {
                for (const countyKey2 of countyKeyList) {
                    if (countyKey === countyKey2) {
                        continue;
                    }
                    
                    console.log(`__dg ${countyKey} ${countyKey2}`);
                    const value = scanFocusDebug['debugUnitMap'][countyKey2];
                    const takeNumber = value["county"]["countykey"]["islandKey"]["takeNumber"];
                    const focusUnits = value["focusUnits"];
                    console.log(`focusUnits ${focusUnits}`);

                    if (takeNumber === takeNumberForDebug) {
                        for (let fu of focusUnits) {
                            console.log(`fu ${fu}`);
                            if (fu['adjacentFUForCounties'] !== null && fu['adjacentFUForCounties'].indexOf(countyKey) >= 0) {
                                let focusedAt = fu['focusedAt'];
                                let hasMotorPos = (focusedAt !== null && focusedAt !== undefined);
                                let motorX = focusedAt['xPosition'] - offset['xPosition'];
                                let motorY = focusedAt['yPosition'] - offset['yPosition'];
                                let color = "#aaff00";
                                let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide,
                                    {device_settings: deviceSettings});
                                if (tileFlag['reverseYTileOrder']['flagY']) {
                                    y = slide.y_fields * (tile_height * uperpixel) - y;
                                }
                                let zProfilePath = '';
                                for (let l = 0; l < focusDirPath.focus_profile_dir_paths.length; l++) {
                                    const path = focusDirPath.focus_profile_dir_paths[l].split("_");
                                    const lastElement = path.pop();
                                    if (fu['unifiedFocusId'] === parseInt(lastElement)) {
                                        zProfilePath = focusDirPath.focus_profile_dir_paths[l];
                                    }
                                }

                                Object.values(focusPlots).forEach(val => {
                                    if (fu['unifiedFocusId'] === parseInt(val['index']) && highestPoint) {
                                        let finalPlotData = getFinalPlotData(val);
                                        let popup = getPlotPopup(zProfilePath, finalPlotData, val['index']);
                                        zdiff = fu['focusedDown'] - highestPoint;
                                        zdiff = Math.round((zdiff + Number.EPSILON) * 100) / 100;
                                        drawLine(x, y - 0.75 * tile_height * uperpixel, 1, this.layer.getSource(),
                                            zdiff, 10, "#f4c2c2", popup, textColor, textSize);
                                    }
                                });


                                let link2 = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path
                                    + zProfileFolderPath + zProfilePath + "/";
                                let finePath = fu['fineLocatedImagePath'];
                                finePath = finePath !== null ? finePath.split(zProfileFolderPath)[1] : '';
                                let bestPath = fu['streakBestFocusedImagePath'];
                                bestPath = bestPath !== null ? bestPath.split(zProfileFolderPath)[1] : '';
                                let isFine = fu['fineLocated'];
                                let imgPath = isFine ? finePath : bestPath;
                                let link1 = getPrefixedUrl(`debug/zprofile/${imgPath}`, this.props.slide, true);
                                let zdiff = fu['focusedDown'] - highestPoint;
                                zdiff = Math.round((zdiff + Number.EPSILON) * 100) / 100;
                                let reuseText = "Reused for counties: ";
                                if (fu['reusedForCounties'] !== null) {
                                    reuseText = reuseText +  fu['reusedForCounties'].join(", ");
                                }
                                let countyId = '';
                                if (fu['countyKeyForFocusPoint'] !== null && fu['countyKeyForFocusPoint'].length > 0) {
                                    countyId = fu['countyKeyForFocusPoint'][0]['countyId'];
                                }
                                let retryCount = fu['tryCount'] ?? 0;
                                if (hasMotorPos) {
                                    let popupText = (
                                        <Stack>
                                            {"Focus ID DOWN " + fu['unifiedFocusId'] + "(" +
                                                fu['focusedDown'] + ")"}
                                            {" CountyId: " + countyId}
                                            <Grid>
                                                <a href={link2}>{"ID " + fu['unifiedFocusId'] + " Location "}</a>
                                                <a href={link1}
                                                    target={"_blank"}>{isFine ? " [Fine Locator Img]"
                                                    : "[Best Focussed Img]"}</a>
                                            </Grid>
                                            <Grid>{"The displayed value is Δz i.e. " + zdiff}</Grid>
                                            <Grid>{"Click on Δz Value to open the focus plot"}</Grid>
                                            <Grid>{reuseText}</Grid>
                                            <Grid>{"Retry count: " + retryCount}</Grid>
                                        </Stack>
                                    );
                                    drawCircle(x, y, 0.75 * tile_height * uperpixel, this.layer.getSource(), "",
                                        7, color, popupText, textColor);
                                }
                            }
                        }
                    }
                }
            }

            for (const key in motorPosToFUListDict) {
                let fuList = motorPosToFUListDict[key];
                for (let index = 0; index < fuList.length; index += 1) {
                    let {countyKey, fu} = fuList[index];
                    let radius = index * 0.5 * tile_height * uperpixel;
                    let focusedAt = fu['focusedAt'];
                    if (focusedAt !== null) {
                        let color = "#f4c2c2";
                        if (takeNumberForDebug === 1) {
                            color = "#21F558";
                        }
                        if (fu['adjacentFUForCounties'] !== null && fu['adjacentFUForCounties'].indexOf(countyKey) >= 0) {
                            // adjacent focus unit
                            color = "#aaff00";
                        }
                        let motorX = focusedAt['xPosition'] - offset['xPosition'];
                        let motorY = focusedAt['yPosition'] - offset['yPosition'];
                        let {x, y} = mapMotorToCanvas(motorX, motorY, this.props.slide,
                            {device_settings: deviceSettings});
                        if (tileFlag['reverseYTileOrder']['flagY']) {
                            y = slide.y_fields * (tile_height * uperpixel) - y;
                        }
    
                        let zProfilePath = '';
                        for (let l = 0; l < focusDirPath.focus_profile_dir_paths.length; l++) {
                            const path = focusDirPath.focus_profile_dir_paths[l].split("_");
                            const lastElement = path.pop();
                            if (fu['unifiedFocusId'] === parseInt(lastElement)) {
                                zProfilePath = focusDirPath.focus_profile_dir_paths[l];
                            }
                        }
                        Object.values(focusPlots).forEach(val => {
                            if (fu['unifiedFocusId'] === parseInt(val['index']) && highestPoint) {
                                let finalPlotData = getFinalPlotData(val);
                                let popup = getPlotPopup(zProfilePath, finalPlotData, val['index']);
                                zdiff = fu['focusedDown'] - highestPoint;
                                zdiff = Math.round((zdiff + Number.EPSILON) * 100) / 100;
                                let sign = index % 2 ? -1 : 1;
                                drawLine(x, y + (sign) * (0.6 * tile_height * uperpixel + radius * (index +1)), 1, this.layer.getSource(),
                                    zdiff, 10, "#E9D6C5", popup, textColor, textSize);
                            }
                        });

                        let link2 = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path +
                            zProfileFolderPath + zProfilePath + "/";
                        let finePath = fu['fineLocatedImagePath'];
                        finePath = finePath !== null ? finePath.split(zProfileFolderPath)[1] : '';
                        let bestPath = fu['streakBestFocusedImagePath'];
                        bestPath = bestPath !== null ? bestPath.split(zProfileFolderPath)[1] : '';
                        let isFine = fu['fineLocated'];
                        let imgPath = isFine ? finePath : bestPath;
                        let link1 = getPrefixedUrl(`debug/zprofile/${imgPath}`, this.props.slide, true);
                        let zdiff = fu['focusedDown'] - highestPoint;
                        zdiff = Math.round((zdiff + Number.EPSILON) * 100) / 100;
                        let reuseText = "Reused for counties: ";
                        if (fu['reusedForCounties'] !== null) {
                            reuseText = reuseText +  fu['reusedForCounties'].join(", ");
                        }
                        let countyId = '';
                        if (fu['countyKeyForFocusPoint'] !== null && fu['countyKeyForFocusPoint'].length > 0) {
                            countyId = fu['countyKeyForFocusPoint'][0]['countyId'];
                        }
                        let retryCount = fu['tryCount'] ?? 0;
                        let popupText = (
                            <Stack>
                                {"Focus ID DOWN " + fu['unifiedFocusId'] + "(" +
                                    fu['focusedDown'] + ")"}
                                {" CountyId: " + countyId}
                                <Grid>
                                    <a href={link2}>{"ID " + fu['unifiedFocusId'] + " Location "}</a>
                                    <a href={link1}
                                        target={"_blank"}>{isFine ? " [Fine Locator Img]"
                                        : "[Best Focussed Img]"}</a>
                                </Grid>
                                <Grid>{"The displayed value is Δz i.e. " + zdiff}</Grid>
                                <Grid>{"Click on Δz Value to open the focus plot"}</Grid>
                                <Grid>{reuseText}</Grid>
                                <Grid>{"Retry count: " + retryCount}</Grid>
                            </Stack>
                        );
                        drawCircle(x, y, 0.6 * tile_height * uperpixel - radius, this.layer.getSource(), "",
                            16, color, popupText, textColor);
                    }
                }
            }
        }
        resolve();
    });
}

export default FocusDebugLayer;